import { render, staticRenderFns } from "./ChangeStatusButtons.vue?vue&type=template&id=0a0897e8"
import script from "./ChangeStatusButtons.vue?vue&type=script&lang=ts"
export * from "./ChangeStatusButtons.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports